import { Grid } from '@material-ui/core';
import React from 'react';
import { IfRender, Text } from 'library';
import { UserPostModel } from '../../NewsfeedModels';
import UserProfilePicture from '../../UserProfilePicture';
interface IProps {
    user: UserPostModel;
}

export default function UserProfileModal({ user }: IProps) {
    return (
        <Grid container item alignItems="center" direction="column">
            <UserProfilePicture profileImage={user.profile_picture.image} size="xl" mr={false} />
            <Grid item style={{ textAlign: 'center' }}>
                <Text variant="h1" bold>
                    {user.first_name} {user.last_name_initial}.
                </Text>
            </Grid>
            <IfRender
                condition={
                    user.address[0] !== undefined &&
                    user.address[0].city !== undefined &&
                    user.address[0].state !== undefined
                }
            >
                <Grid item>
                    <Text variant="body1">
                        {user.address[0].city}, {user.address[0].state}
                    </Text>
                </Grid>
            </IfRender>
        </Grid>
    );
}
